import {BASE_URL} from "../config/api";

export const addDepartment = async (payload) => {
  const response = await fetch(`${BASE_URL}/department/createDepartment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to add user");
  }

  return await response.json();
};


export const fetchAllDepartments = async () => {
  const response = await fetch(`${BASE_URL}/department/fetchAllDepartment`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch departments");
  }

  const data = await response.json();
  return data.departments; // Assuming API returns { departments : [...] }
};

export const fetchDepartmentById = async (id) => {
  const response = await fetch(`${BASE_URL}/department/fetchDepartmentById/${id}`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch department");
  }

  const data = await response.json();
  return data.department;
};

export const fetchDepartmentFaculties= async (id) => {
  const response = await fetch(`${BASE_URL}/department/fetchDepartmentFaculties/${id}`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch department");
  }

  const data = await response.json();
  return data.faculty;
};

export const updateDepartment = async (id, formData) => {
  const response = await fetch(`${BASE_URL}/department/updateDepartment/${id}`, {
    method: "POST",
    body: formData,
  });

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const text = await response.text();
    throw new Error("Server did not return JSON:\n" + text);
  }

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update department");
  }

  return await response.json();
};



// departmentService.js
export const assignDepartmentHOD = async (departmentId, hodUserId, addedByEmail, department_name) => {
  const response = await fetch(`${BASE_URL}/department/assign-hod`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      department_id: departmentId,
      hod_user_id: hodUserId,
      addedbyemail: addedByEmail,
      department_name: department_name,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Failed to assign HOD");
  }

  return response.json();
};

